module.exports = __webpack_public_path__ + "img/CU.64b0014c.png";